var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstHorizontalOffsetLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 636,
    height: 500,
    viewBox: "0 0 636 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_232_940)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.24 226.26L41.69 135.62L44.5 132.68L43.29 118.38L40.42 115.44L36.78 86.5901C36.78 86.5901 34.87 79.3101 39.84 74.8501",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.65 221.72C63.65 221.72 65.21 208.25 73.93 208.19C82.64 208.13 83.31 208.19 83.31 208.19",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.23 208.16H148.86",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.95 208.16H203.75L205.22 211.32V255.36C205.22 258.08 204.28 260.74 202.46 262.77C200.48 264.97 197.34 267.26 192.71 267.52",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.28 67.8701L-26.21 74.6801C-26.21 74.6801 -12.93 78.4201 -9.87 95.1101L12.26 192.81L13.62 264.47C13.62 264.47 14.22 271.62 8.67999 273.83C3.14999 276.04 1.02 276.89 1.02 276.89C1.02 276.89 -12.68 276.89 -16.51 276.89C-16.51 276.89 -25.36 271.78 -36.77 272.12C-48.18 272.46 -72 279.44 -72 279.44",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30.62 299.41C-30.62 299.41 -21.78 313.91 -19.39 327.27C-17 340.63 1.04001 330.33 1.04001 330.33L10.23 325.22C10.23 325.22 24.02 316.45 17.89 299.26C13.26 286.28 -12.24 292.88 -12.24 292.88L-19.75 295.54L-30.62 299.41ZM-30.62 299.41L-71.99 314.08",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.76 295.56C-19.76 295.56 -16.22 302.73 -13.53 310.8C-11.73 316.17 -10.31 321.94 -10.55 326.26L-9.70001 328.56C-9.70001 328.56 16.47 322.91 19.09 303.82",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.52 310.8L9.11998 302.26L10.48 307.11L-11.9 316.23",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.27 278.75C-11.27 278.75 10.92 276.96 21.84 286.94L40.35 277.58",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.99 59.7002L-22.46 69.9102C-22.46 69.9102 -5.26999 73.6502 -1.51999 86.5902C2.23001 99.5302 23.84 199.61 23.84 199.61V269.06L1.27002 279.1",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.28 46.77L-9.18004 61.83C-9.18004 61.83 0.13996 64.64 4.09996 82.26C8.05996 99.88 42.91 252.05 42.91 252.05",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.28 38.8501L3.83997 59.7001C3.83997 59.7001 10.35 58.2501 15.84 84.3001C21.33 110.34 48.01 240.81 48.01 240.81",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.41 115.45L35.24 121.32L36.78 134.85L41.69 135.62",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.17 85.8901L36.78 86.6001",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.63 67.8702H111.07L114.65 63.7002H159.84L164.95 67.8702H223.41L231.84 74.8502H39.84L25.54 66.4302L8.82001 63.7002",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.41 67.8699L214.98 57.2299C214.98 57.2299 71.87 56.8499 41.68 55.6999C11.49 54.5499 -28.09 42.4199 -28.09 42.4199",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.99 57.23V0",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.52002 14.5998C-1.52002 14.5998 18.91 18.8098 36.78 19.1998C54.65 19.5898 199.42 19.1998 199.42 19.1998V2.33984",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.99 365.06C-71.99 365.06 17.88 324.63 40.35 316.23",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.76 354.01L-12.89 367.06C-12.89 367.06 -9.95002 371.97 -5.10002 369.23C-0.250021 366.49 34.35 347.27 34.35 347.27",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.27 258.23H210.66C208.83 258.23 207.32 256.73 207.32 254.89V220.33C207.32 218.5 208.82 216.99 210.66 216.99H223.27C225.1 216.99 226.61 218.49 226.61 220.33V254.89C226.6 256.73 225.1 258.23 223.27 258.23Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.22 212.64H227.92C227.92 212.64 231.62 212.47 231.92 218C232.22 223.53 231.92 252.64 231.92 252.64L377.11 265.83C377.11 265.83 382.64 266.51 388.09 264.98C393.54 263.45 412.43 258.24 412.43 258.24C412.43 258.24 420.69 254.86 432.52 254.94C444.35 255.02 565.46 254.94 565.46 254.94V261.75H432.69C432.69 261.75 422.56 261.54 412.78 265.99C402.99 270.43 389.46 273.67 389.46 273.67C389.46 273.67 382.48 274.1 375.84 273.67L231.67 259.53L230.14 293.57C230.14 293.57 229.97 295.36 226.61 295.44C223.25 295.53 174.52 295.48 174.52 295.48",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.33 272.13H220.61C220.61 272.13 224.7 272.3 224.87 276.22C225.04 280.13 225.04 280.13 225.04 280.13V285.92C225.04 285.92 225.13 289.15 222.15 289.15C219.17 289.15 205.98 289.15 205.98 289.15L201.89 286.09H182.35",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.26 217V250L293.97 255.28V220.04L244.26 217Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9 221.06V245.58L288.86 250V224.81L250.9 221.06Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.99 256.3H307.52C305.43 256.3 303.72 254.59 303.72 252.5V224.02C303.72 221.93 305.43 220.22 307.52 220.22H313.99C316.08 220.22 317.79 221.93 317.79 224.02V252.5C317.8 254.59 316.08 256.3 313.99 256.3Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.92 212.64L372.01 221.07C372.01 221.07 381.37 221.84 385.71 227.71C390.05 233.58 401.7 261.21 401.7 261.21",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.34 259.09L394.73 225.32C394.73 225.32 393.84 222.87 390.24 220.47C387.34 218.54 382.69 216.66 375.32 216.13L203.75 208.17",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.6 246.09H581.65",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.77 254.06V248.98L438.14 235.19L531.24 236.92L562.9 250H423.84L412.77 254.06Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.56 285.23H432.35C430.29 285.23 428.61 283.54 428.61 281.49V272.47C428.61 270.41 430.3 268.73 432.35 268.73H467.92H562.56C564.62 268.73 566.3 270.42 566.3 272.47V281.49C566.31 283.55 564.62 285.23 562.56 285.23Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.92 268.72V285.23",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.82 268.72V285.23",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.71 273.66H473.71V280.64H521.71V273.66Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.84 273.66L370.73 317.02L355.67 366.68L354.39 375.87H362.05L391.67 365.66L406.99 339.87C406.99 339.87 411.46 328.89 425.37 328.38C439.28 327.87 568.6 318.68 568.6 318.68L577.54 285.23V277.14C577.67 266.63 586.56 268.71 586.56 268.71V258.16",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.91 293.99L236.93 282.01C235.31 281.86 234.11 280.41 234.27 278.8L235.41 266.63C235.56 265.01 237.01 263.81 238.62 263.97L290.83 268.86L366.6 275.95C368.22 276.1 369.42 277.55 369.26 279.16L368.12 291.33C367.97 292.94 366.52 294.14 364.91 293.99Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.82 268.85L288.86 286.87",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.76 270.71L308.7 288.73",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.44 305.17L296.32 314.13C298.05 314.39 299.23 316.03 298.9 317.75L292.62 351.3C292.32 352.89 290.8 353.93 289.21 353.64L234.24 343.45",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.73 299.19L307.41 311.62L356.77 319.45L358.99 306L309.73 299.19Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.83 366.98C387.83 366.98 373.12 417.66 358.99 431.78C344.86 445.91 326.14 442.33 326.14 442.33L250.91 426.33C250.91 426.33 219.85 415.95 239.76 352.37",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.53 397.57C273.383 397.57 281.37 394.113 281.37 389.85C281.37 385.586 273.383 382.13 263.53 382.13C253.677 382.13 245.69 385.586 245.69 389.85C245.69 394.113 253.677 397.57 263.53 397.57Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.26 394.51L248.04 393.67L249.58 410.47L255.69 415.25",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.8 405.75C271.8 405.11 286.86 391.45 286.86 391.45C286.86 391.45 309.65 381.56 318.65 396.56L307.54 411.88",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.95 407.79C284.95 407.79 293.78 398.11 311.61 406.27",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.86 391.45V406.23",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.5 370.55L360.18 394.52L349.29 393.68L354.4 375.88C354.4 375.88 244.74 353.41 239.76 352.39C234.78 351.37 234.26 343.45 234.26 343.45L235.46 305.17L235.68 298V290.6C235.68 290.6 235.77 286.21 244.28 286.87L361.56 301.57C361.56 301.57 366.67 301.44 366.41 308.21C366.15 314.98 370.75 317.02 370.75 317.02",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.05 375.87L360.18 394.51",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.98 354.48L249.2 373.92H240.35L235.42 368.93C235.42 368.93 235.37 386.34 244.26 394.51V415.96C244.26 415.96 249.71 422.47 254.05 421.58L259.16 401.92C259.16 401.92 277.29 409.2 324.27 415.45L325.72 434C325.72 434 327.51 437.4 330.23 437.4C332.95 437.4 340.1 437.4 340.1 437.4C340.1 437.4 343.21 436.72 344.61 433.14C346.01 429.57 346.14 414.5 346.14 414.5C346.14 414.5 361.05 409.41 369.28 397.55C377.51 385.69 382.19 368.92 382.19 368.92",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.35 373.92L239.75 352.38",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.2 373.92L349.29 393.67",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.99 339.87L409.22 353.71L417.97 407.79H427.29",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.77 347.28L409.22 353.71",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.6 318.68L564.6 383.79",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.6 383.79L577.29 318.68L580.95 317.75L678.72 358.26",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.48 350.49L631.8 373.06C631.8 373.06 637.16 376.95 641.12 371.15C645.08 365.35 647.92 358.48 647.92 358.48",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.58 374.34L623.66 390.04",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.58 252.94L92.43 223.96C92.43 223.96 93.96 219.87 97.41 218.6C100.86 217.32 170.18 218.6 170.18 218.6",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.37 218.03H194.05C194.05 218.03 200.94 220.13 201.45 226.26C201.85 231.04 202.25 248.35 202.4 255.73C202.45 258.18 201.26 260.52 199.19 261.82C197.83 262.67 196.06 263.51 193.92 263.96",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.65 321.49C138.05 321.66 151.67 321.49 151.67 321.49L161.54 315.19H170.18C170.18 315.19 172.14 312.84 174.52 295.48L178.56 309.18V320.46L162.73 332.55C162.73 332.55 127.41 332.29 126.99 332.55C126.56 332.81 114.63 325.46 114.63 325.46",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.18 315.19L175.72 322.64",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.22 319.86L162.73 332.55",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2 315.19C89.2 315.19 104.09 317.75 122.73 314.68C122.73 314.68 131.5 313.91 132.77 301.57C134.05 289.23 129.88 286.93 129.88 286.93H99.92C99.92 286.93 94.81 291.44 89.2 300.72C83.58 310 89.2 315.19 89.2 315.19Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.33 267.53C151.16 268.47 143.59 278.51 145.71 296.13C147.84 313.75 174.9 283.02 174.9 283.02C174.9 283.02 184.86 271.36 177.2 266.34C169.54 261.32 151.33 267.53 151.33 267.53Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.75 276.04C51.75 276.04 51.92 286.17 60.94 296.81C69.96 307.45 83.66 291.32 85.62 272.13C85.62 272.13 85.88 263.01 75.07 263.95C64.26 264.89 48.35 266.43 51.75 276.04Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.88 242.85C57.88 242.85 59.24 259.36 91.24 252.94C91.24 252.94 117.28 237.75 147.24 252.05C147.24 252.05 179.84 261.16 185.37 247.96C185.37 247.96 188.14 207.79 128.88 205.75C128.88 205.75 88.18 201.67 57.88 242.85Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.86 259.22C46.03 240.13 60.46 222.84 76.61 212.13C92.09 201.86 110.42 197.04 128.88 196.55C158.85 195.76 187.62 208.41 194.61 239.67C196.3 247.23 196.48 254.68 194.22 262.18C182.57 300.92 141.52 326.68 101.79 326.2C79.36 325.93 52.4 315.81 42.98 294.02C37.98 282.46 37.8 270.52 40.86 259.22Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.11 275.32C44.03 257.63 52.83 239.06 66.17 226.4C92.4 201.51 146.97 189.87 175.73 217.18C200.96 241.14 187.25 281.67 163 300.34C135.42 321.58 84.59 331.06 57.66 303.52C49.58 295.26 45.73 285.43 45.11 275.32Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.09 385.19C233.09 385.19 221.12 444.55 223.33 457.66L245.69 477.4C245.69 477.4 348.6 489.66 372.01 482.51C395.41 475.36 424.86 446.42 424.86 446.42C424.86 446.42 427.67 436.55 427.29 432.8C426.91 429.06 417.97 407.78 417.97 407.78",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.43 421.06L362.05 452.21C362.05 452.21 353.62 461.4 329.37 458.85C305.11 456.3 249.98 442.74 249.98 442.74C249.98 442.74 228.48 433.32 228.12 412.12",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.25 415.25L356.44 442.74C356.44 442.74 343.59 450.76 327.5 447.44C311.41 444.12 248.01 428.55 248.01 428.55C248.01 428.55 233.71 422.31 230.48 398.83",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.84 74.8501L253.03 84.0401H371.24L391.67 74.8501H589.03L600.77 65.4001C600.77 65.4001 616.6 63.6101 628.34 59.7801C640.08 55.9501 678.71 41.1401 678.71 41.1401",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.03 74.8501C589.03 74.8501 592.73 78.8101 592.09 86.5901C591.45 94.3701 587.75 131.53 587.75 131.53L582.9 133.32L581.37 147.62L582.9 154L568.35 229.23C575.16 233.23 583.67 228.72 583.67 228.72L579.24 244.38L586.56 251.53V258.17H569.54C569.45 247.96 564.6 246.08 564.6 246.08L541.96 235.87C537.87 233.23 529.19 232.81 529.19 232.81L428.93 228.38L400.56 238.81L406.04 232.72L390.24 220.47",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.65 59.02C630.65 59.02 616.1 65.02 615.08 86.6H592.1",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.07 86.6001L583.67 228.72",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.72 49.1499C678.72 49.1499 629.66 57.8299 621.39 67.0199",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.72 62.6001L651.92 68.5601C651.92 68.5601 634.05 75.3701 629.11 90.6901C624.17 106.01 603.92 202.01 603.92 202.01V271.8",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.72 72.8101L658.05 74.8501C658.05 74.8501 638.31 77.4 632.01 94.94L607.67 201.49V272.72L583.67 271.78L582.49 277.85L581.65 282.16L596.14 324.03",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.05 74.8501C658.05 74.8501 645.87 76.7601 641.32 94.2501C636.77 111.74 616.6 194.08 616.6 194.08V268.72L620.43 275.27L678.72 293.14",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.49 277.86L606.65 290.34L609.2 315.87C609.2 315.87 611.63 325.44 618.39 328.38L635.6 336.55C635.6 336.55 645.65 339.23 647.91 332.98C650.18 326.72 659.24 305.66 659.24 305.66C659.24 305.66 657.64 293.54 665.21 289.01",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.65 290.34L622.22 283.45C622.22 283.45 627.15 281.02 635.6 283.45C644.05 285.88 662.04 291.98 662.04 291.98",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.03 304.14L621.2 295.48C621.2 295.48 627.02 291.61 635.6 293.14C639.04 293.76 643.53 295.07 647.66 296.42C653.82 298.43 659.21 300.53 659.21 300.53",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.66 296.43C647.66 296.43 635.1 319.74 635.6 336.56",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.58 0L409.34 59.02L391.67 74.85",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9 0V33.49C250.9 33.49 250.03 44.47 261.45 44.6C272.88 44.73 364.6 44.6 364.6 44.6C364.6 44.6 372.77 46.2 373.15 36.56C373.53 26.92 373.15 0.0100021 373.15 0.0100021",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.9 33.4902V58.6402C250.9 58.6402 252.45 69.4402 258.77 69.2802C265.09 69.1102 363.58 69.2802 363.58 69.2802C363.58 69.2802 372.2 68.8602 372.01 64.0102C371.82 59.1602 373.25 33.5002 373.25 33.5002",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.99 225.7L568.35 229.23L552.41 240.59",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.24 252.94C91.24 252.94 85.28 269.88 92.94 282.98H134.05C134.05 282.98 149.58 272.47 147.24 252.04",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.95 282.98L99.92 286.94",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.05 282.98L129.88 286.94",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.39 293.95C77.39 293.95 80.93 298.08 89.2 300.72",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9 300.2C132.9 300.2 140.92 298.13 145.34 294.69",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.29 255.11C169.29 255.11 170.82 260.61 169.29 263.95",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.48 254.06C73.48 254.06 68.35 258.72 68.46 264.38",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.36 19.08L38.83 0",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.97 0V22.35L594.39 18.17L589.63 0",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.34 44.6998L579.75 41.1498C579.75 41.1498 620.09 41.1498 654.64 35.5298",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.34 59.0199L581.65 56.2999C581.65 56.2999 630.99 52.5599 661.79 41.1499",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.39 18.1699C594.39 18.1699 611.51 17.6599 630.18 13.3999",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.29 205.48H202.41L250.89 208.6L381.55 217",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89 208.6H314.81L429.45 216.81",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.79 224.99L404.43 216.81H429.45V221.89H413.62V225.32",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.45 216.81H521.88V219.85H429.45",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61.78 500L-46.21 481.83C-46.21 481.83 -38.17 474.81 -48.51 470.6C-48.51 470.6 -59.32 469.24 -59.74 461.24C-60.17 453.24 -51.83 438.6 -51.83 438.6C-51.83 438.6 -32.81 405.43 -9.70003 392.47C13.41 379.51 28.09 382.64 28.09 382.64C28.09 382.64 35.94 362.47 34.35 347.28C32.75 332.09 19.45 338.34 19.45 338.34C-32.47 357.36 -71.28 378.68 -71.28 378.68",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.18 388.77C194.18 388.77 177.2 408.3 168.52 437.41C159.84 466.52 139.12 474.18 139.12 474.18C139.12 474.18 128.31 474.18 126.65 479.29C124.99 484.4 120.78 500.02 120.78 500.02",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.35 500C100.35 500 129.68 428.59 145.34 411.87C160.99 395.15 179.25 383.79 179.25 383.79",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38.97 500C-39.31 498.42 6.33996 445.36 19.45 418.53C32.56 391.7 28.09 382.63 28.09 382.63C28.09 382.63 118.22 373.84 179.24 383.79C179.24 383.79 191.34 382.25 194.18 388.76C197.02 395.27 196.03 420.29 196.03 420.29L191.24 437.4L164.69 500",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.45 418.53L139.12 420.14",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.51 411.87C22.51 411.87 75.17 399.23 145.33 411.87",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.43 412.13L678.72 371.79L604.86 339.88C604.86 339.88 595.73 337.37 592.48 350.5L598.61 386.09C578.82 380.09 496.01 381.92 496.01 381.92C496.01 381.92 420.44 380.05 430.99 390.05C441.54 400.05 456.69 436.05 461.29 453.24C465.89 470.43 483.08 476.05 483.08 476.05C483.08 476.05 482.7 466.26 487.68 470.6C492.66 474.94 500.7 500.01 500.7 500.01",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.72 446.09C665.77 420.18 658.48 416.35 644.43 401.66C630.39 386.98 598.6 386.09 598.6 386.09C598.6 386.09 598.22 408.54 606.64 423.55C615.07 438.56 662.03 500.01 662.03 500.01",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.94 383.79C440.94 383.79 462.77 394 481.54 422.08C500.31 450.17 521.71 500 521.71 500",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.54 422.09L606.65 423.54",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.65 416.57C477.65 416.57 538.98 401.17 604.22 418.46",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.98 388.47C429.98 388.47 429.7 389.92 429.36 392.44C428.58 398.2 427.48 409.57 428.6 422.09C430.22 440.09 432.51 464.73 436.86 472.64L435.58 500",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.36 392.44C429.36 392.44 446.31 408.22 461.63 462.09C461.63 462.09 469.97 475.11 483.08 476.05",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.77 386.09C600.77 386.09 603.07 410.14 608.94 422.82C609.96 425.03 664.85 500.01 664.85 500.01",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.38 384.22C438.38 384.22 464.44 397.19 479.25 422.09C494.06 446.98 498.4 453.97 519.59 500.01",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.28 382.35C25.28 382.35 31.19 391.93 15.84 420.15C0.489996 448.37 -42.37 500.01 -42.37 500.01",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.29 383.79C181.29 383.79 157.23 398.21 141.33 421.44C125.43 444.67 102.9 500 102.9 500",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.97 391.45C194.97 391.45 174.01 418.18 168.52 444.39C168.52 444.39 159.97 468.18 139.8 475.84C139.8 475.84 133.12 474.63 129.33 478.78C125.54 482.93 122.56 500.02 122.56 500.02",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 86,
    x2: 320,
    y2: 208,
    stroke: "#2D9DC9",
    strokeWidth: 4,
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.145 156.931C143.979 155.839 144.741 154.96 145.846 154.967L190.559 155.244C191.663 155.251 192.693 156.141 192.858 157.233L197.483 187.778C197.648 188.869 196.886 189.748 195.782 189.741L151.068 189.464C149.964 189.457 148.935 188.567 148.769 187.475L144.145 156.931ZM172.578 185.007L173.769 185.012C174.065 185.013 174.246 184.714 174.172 184.343L173.071 178.84C172.997 178.469 172.696 178.168 172.4 178.166L171.209 178.161C170.912 178.159 170.732 178.459 170.806 178.83L171.907 184.333C171.981 184.704 172.281 185.005 172.578 185.007ZM171.792 167.745L170.601 167.739C170.305 167.738 170.004 167.436 169.928 167.059L168.828 161.555C168.754 161.185 168.934 160.885 169.23 160.887L170.422 160.892C170.718 160.893 171.018 161.195 171.093 161.566L172.195 167.076C172.269 167.447 172.088 167.746 171.792 167.745ZM160.488 174.301L165.756 174.321C166.111 174.322 166.329 174.02 166.242 173.646L165.893 172.142C165.806 171.768 165.448 171.463 165.093 171.462L159.824 171.443C159.47 171.441 159.252 171.744 159.339 172.118L159.688 173.621C159.775 173.995 160.133 174.3 160.488 174.301ZM177.108 173.756L176.759 172.253C176.672 171.879 176.89 171.576 177.244 171.577L182.513 171.597C182.868 171.598 183.226 171.903 183.313 172.277L183.662 173.78C183.749 174.155 183.531 174.457 183.177 174.456L177.908 174.436C177.553 174.435 177.195 174.13 177.108 173.756ZM163.807 180.896L164.991 181.959C165.289 182.226 165.673 182.228 165.847 181.962L168.487 178.07C168.667 177.805 168.572 177.377 168.276 177.117L167.092 176.054C166.794 175.787 166.41 175.785 166.237 176.051L163.596 179.943C163.421 180.201 163.516 180.629 163.807 180.896ZM176.771 169.849C176.597 170.114 176.213 170.113 175.915 169.845L174.731 168.783C174.435 168.522 174.34 168.094 174.52 167.829L177.161 163.937C177.335 163.672 177.718 163.673 178.016 163.94L179.2 165.003C179.497 165.263 179.591 165.691 179.411 165.957L176.771 169.849Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.871 176.956C317.675 176.199 317.713 174.933 316.956 174.129L304.614 161.026C303.857 160.222 302.591 160.184 301.787 160.941C300.983 161.699 300.945 162.964 301.702 163.768L312.673 175.415L301.026 186.386C300.222 187.143 300.184 188.409 300.941 189.213C301.699 190.017 302.964 190.055 303.768 189.298L316.871 176.956ZM197.129 170.544C196.325 171.301 196.287 172.567 197.044 173.371L209.386 186.474C210.143 187.278 211.409 187.316 212.213 186.559C213.017 185.801 213.055 184.536 212.298 183.732L201.327 172.085L212.974 161.114C213.778 160.357 213.816 159.091 213.059 158.287C212.301 157.483 211.036 157.445 210.232 158.202L197.129 170.544ZM315.56 173.501L198.56 170.001L198.44 173.999L315.44 177.499L315.56 173.501Z",
    fill: "#2D9DC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_232_940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 636,
    height: 500,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstHorizontalOffsetLeft);
export default __webpack_public_path__ + "static/media/instHorizontalOffsetLeft.32a9315ea62d9c6a7510831742f71e38.svg";
export { ForwardRef as ReactComponent };